<template>
  <footer class="app-footer">
    <div class="footer-container">
      <!-- <div class="footer-top">
        <a @click="yq">友情链接</a> | <a @click="fl">法律声明</a> |
        <a @click="lianxi">联系我们</a> | <a @click="xx">信息披露</a> |
        <a>客服电话：4000-626-567</a>
      </div>
      <div class="footer-bottom">
        <span>版权所有：天津和治友德制药有限公司</span>
        <span
          ><a href="http://beian.miit.gov.cn/" target="_blank"
            >津ICP备15008338号</a
          >&nbsp; &nbsp;&nbsp;&nbsp;<a
            href="https://beian.mps.gov.cn/#/query/webSearch"
            target="_blank"
            >津公网安备12011502000898号</a
          ></span
        >
      </div> -->
      <div style="font-size: 12px">All rights reserved by Fohoway Group.</div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
  methods: {
    //跳转客服
    lianxi() {
      this.$router.push({
        path: `/about?id=${11}&unit_id=1`, // 将id拼接到路由路径中
      });
    },
    //友情链接
    yq() {
      this.$router.push({
        path: `/news?id=${21}&unit_id=2`, // 将id拼接到路由路径中
      });
    },
    //法律声明
    fl() {
      this.$router.push({
        path: `/news?id=${22}&unit_id=2`, // 将id拼接到路由路径中
      });
    },
    //信息披露
    xx() {
      this.$router.push({
        path: `/news?id=${23}&unit_id=2`, // 将id拼接到路由路径中
      });
    },
  },
};
</script>

<style scoped>
a {
  cursor: pointer;
}
.app-footer {
  background-color: #f2eada;
  color: #333;
  padding: 10px 0;
}

.footer-container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  text-align: center;
}

.footer-top {
  margin-bottom: 8px;
  font-size: 14px;
}

.footer-bottom {
  font-size: 13px;
  color: #555;
}

.footer-bottom span {
  margin: 0 5px;
}
</style>
